// Which browser this is, read from its user agent: small enough for the
// shell, so the setup list names the right way to install from its first
// paint. The steps each browser takes (homeScreen.ts) load later. The
// shell's own hint (app/shell/hintVariant.ts) only knows whether to show
// itself; this says which browser asks.
import { isIOS, isMacSafari } from '@app/shell/hintVariant';

export type Browser =
  | 'ios-safari' | 'ios-other'
  | 'android-chrome' | 'android-samsung' | 'android-firefox' | 'android-other'
  | 'mac-safari' | 'desktop-chrome' | 'desktop-edge' | 'desktop-firefox'
  | 'other';

export interface BrowserEnv { ua: string; platform: string; maxTouchPoints: number }

export function detectBrowser(env: BrowserEnv): Browser {
  const { ua } = env;
  if (isIOS(env)) return /CriOS|FxiOS|EdgiOS|OPiOS/.test(ua) ? 'ios-other' : 'ios-safari';
  if (/Android/.test(ua)) {
    if (/SamsungBrowser/.test(ua)) return 'android-samsung';
    if (/Firefox/.test(ua)) return 'android-firefox';
    if (/EdgA|OPR|YaBrowser/.test(ua)) return 'android-other';
    return /Chrome\//.test(ua) ? 'android-chrome' : 'android-other';
  }
  if (/Edg\//.test(ua)) return 'desktop-edge';
  if (/Firefox\//.test(ua)) return 'desktop-firefox';
  if (/OPR\//.test(ua)) return 'other';
  if (/Chrome\/|Chromium\//.test(ua)) return 'desktop-chrome';
  if (isMacSafari(env)) return 'mac-safari';
  return 'other';
}
